// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../.yarn/__virtual__/css-loader-virtual-85d6bada94/0/cache/css-loader-npm-7.1.1-25b990b98a-435a21f195.zip/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../.yarn/__virtual__/css-loader-virtual-85d6bada94/0/cache/css-loader-npm-7.1.1-25b990b98a-435a21f195.zip/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --document-section-color: #85AAEC;
  --document-section-name-color: var(--document-section-color);
  --document-section-replacement-color: #ECDA85;
}

.document-section-block {
  position: relative;
  z-index: 0;
  padding-top: 1.25rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  border: 2px solid var(--document-section-color);
  border-radius: 4px;
}

.document-section-block:before {
  content: attr(section-name);
  position: absolute;
  top: 0;
  left: 0;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  background: var(--document-section-name-color);
}

.document-section-block:after {
  content: attr(section-replacement);
  position: absolute;
  top: 0;
  right: 0;
  font-size: 0.6125rem;
  padding: 0.125rem 0.25rem;
  background: var(--document-section-replacement-color);
}`, "",{"version":3,"sources":["webpack://./assets/js/components/editorjs/components/block-documentsection/index.css"],"names":[],"mappings":"AAAA;EACC,iCAAA;EACA,4DAAA;EACA,6CAAA;AACD;;AAEA;EACC,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,+CAAA;EACA,kBAAA;AACD;;AAEA;EACE,2BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,uBAAA;EACA,8CAAA;AACF;;AAEA;EACE,kCAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,oBAAA;EACA,yBAAA;EACA,qDAAA;AACF","sourcesContent":[":root {\r\n\t--document-section-color: #85AAEC;\r\n\t--document-section-name-color: var(--document-section-color);\r\n\t--document-section-replacement-color: #ECDA85;\r\n}\r\n\r\n.document-section-block {\r\n\tposition: relative;\r\n\tz-index: 0;\r\n\tpadding-top: 1.25rem;\r\n\tpadding-left: 0.25rem;\r\n\tpadding-right: 0.25rem;\r\n\tborder: 2px solid var(--document-section-color);\r\n\tborder-radius: 4px;\r\n}\r\n\r\n.document-section-block:before {\r\n\t\tcontent: attr(section-name);\r\n\t\tposition: absolute;\r\n\t\ttop: 0;\r\n\t\tleft: 0;\r\n\t\tfont-size: 0.75rem;\r\n\t\tpadding: .25rem .5rem;\r\n\t\tbackground: var(--document-section-name-color);\r\n\t}\r\n\r\n.document-section-block:after {\r\n\t\tcontent: attr(section-replacement);\r\n\t\tposition: absolute;\r\n\t\ttop: 0;\r\n\t\tright: 0;\r\n\t\tfont-size: 0.6125rem;\r\n\t\tpadding: .125rem .25rem;\r\n\t\tbackground: var(--document-section-replacement-color);\r\n\t}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
